import type { Review } from './api.ts'
import type { GuidedStep } from './guidedSteps.ts'

/**
 * Corrections as the screens need them (#439, ADR 0025).
 *
 * Who works corrections is a permission, and the API refuses what the role
 * does not allow; this side only decides what to offer.
 */

/**
 * The two ways to look at a conferência waiting on a correction (#439):
 * everything, or only what was marked *Corrigir no sistema*.
 */
export enum ReviewView {
  Comparison = 'comparison',
  Correction = 'correction',
}

/**
 * The steps holding something marked *Corrigir no sistema*: what the Correção
 * view walks (#439). Empty when nothing is marked, and the view is not offered.
 */
export function correctionSteps(
  steps: readonly GuidedStep[],
  decisions: readonly Review[],
): readonly GuidedStep[] {
  const marked = new Set(
    decisions.filter((d) => d.decision === 'corrected').map((d) => d.fingerprint),
  )
  return steps.filter((step) => step.findings.some((f) => marked.has(f.fingerprint)))
}

/**
 * Whether sending a correction back for another look should take this person
 * off it, on to the next one waiting on a correction.
 *
 * Only when they could not watch it: a role that sees nothing but what waits
 * on a fix is refused the moment it is being read again. Anyone who sees the
 * analysis stays and watches it, as with any other Atualizar. Unknown -- the
 * session not yet loaded -- counts as seeing, as everywhere else.
 */
export function leavesOnReverify(visibleStatuses: readonly string[] | undefined): boolean {
  return visibleStatuses !== undefined && !visibleStatuses.includes('reverifying')
}
